(function () {
  var CART_EMPTY_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart-empty" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L28.4 11.8zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1-9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z"></path></svg>';
  var CART_FULL_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path></svg>';
  var originalFetch = window.fetch;
  var _iconObserver = null;
  var _lastCount = -1;

  /* ── Banner ── */
  function initBanner() {
    var msgs = document.querySelectorAll('.cd-banner-msg');
    if (msgs.length < 2) return;
    var idx = 0;
    if (window._cdBannerInterval) clearInterval(window._cdBannerInterval);
    window._cdBannerInterval = setInterval(function () {
      msgs[idx].classList.remove('cd-banner-active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('cd-banner-active');
    }, 3000);
  }

  /* ── Price Summary ── */
  window.cdToggleSummary = function () {
    var s = document.getElementById('cd-price-summary');
    var c = document.querySelector('.cd-chevron');
    if (!s) return;
    var show = s.style.display === 'none' || !s.style.display;
    s.style.display = show ? 'block' : 'none';
    if (c) c.classList.toggle('cd-chevron-up', show);
  };

  /* ── Reco helpers ── */
  function revealNextHidden(carousel) {
    if (!carousel) return;
    var h = carousel.querySelector('.cd-reco-hidden');
    if (h) {
      h.classList.remove('cd-reco-hidden');
      h.style.opacity = '0';
      h.style.transform = 'translateX(20px)';
      requestAnimationFrame(function () {
        h.style.transition = 'opacity .3s,transform .3s';
        h.style.opacity = '1';
        h.style.transform = 'translateX(0)';
      });
    }
  }

  /* ── Reco Add (delegated) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cd-reco-add');
    if (!btn) return;
    var vid = btn.dataset.variantId;
    if (!vid) return;
    btn.classList.add('cd-adding');
    btn.textContent = '...';
    var card = btn.closest('.cd-reco-card');
    var carousel = btn.closest('.cd-reco-carousel');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        fireCartUpdated(cart);
        if (card) {
          card.style.transition = 'opacity .3s,transform .3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(.8)';
          setTimeout(function () { card.remove(); revealNextHidden(carousel); }, 300);
        }
        refreshDrawer(function () { updateCartBubble(cart); });
      })
      .catch(function () { btn.classList.remove('cd-adding'); btn.textContent = 'Add'; });
  });

  /* ── Qty minus disable ── */
  function initMinusDisable() {
    document.querySelectorAll('cart-drawer .cd-qty-input').forEach(function (qi) {
      var input = qi.querySelector('.quantity__input');
      var minus = qi.querySelector('button[name="minus"]');
      if (!input || !minus) return;
      function check() {
        var v = parseInt(input.value, 10) || 1;
        var m = parseInt(input.getAttribute('min'), 10) || 1;
        minus.toggleAttribute('disabled', v <= m);
      }
      check();
      input.addEventListener('change', check);
      input.addEventListener('input', check);
      new MutationObserver(check).observe(input, { attributes: true, attributeFilter: ['value'] });
    });
  }

  /* ── Refresh Drawer ── */
  function refreshDrawer(cb) {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap('cart-drawer-items', doc);
        swap('.drawer__footer', doc);
        swap('.cd-cart-details-header', doc);
        var cd = document.querySelector('cart-drawer');
        var nd = doc.querySelector('cart-drawer');
        if (cd && nd) cd.classList.toggle('is-empty', nd.classList.contains('is-empty'));
        initMinusDisable();
        initBanner();
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }
  function swap(sel, doc) {
    var n = doc.querySelector(sel), o = document.querySelector(sel);
    if (n && o) o.innerHTML = n.innerHTML;
  }

  /* ══════════════════════════════════════
     Cart Bubble + SVG Swap + Animation
     ══════════════════════════════════════ */
  function updateCartBubble(cart) {
    var count = cart.item_count;
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    // Skip if nothing changed
    if (count === _lastCount) return;
    _lastCount = count;

    // Pause observer
    if (_iconObserver) _iconObserver.disconnect();

    // Clean existing bubbles
    var old = document.getElementById('cd-cart-count-bubble');
    if (old) old.remove();
    icon.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.remove(); });

    // Swap SVG with fade
    var wrap = icon.querySelector('.svg-wrapper');
    if (wrap) {
      wrap.style.transition = 'opacity .25s ease';
      wrap.style.opacity = '0';
      setTimeout(function () {
        wrap.innerHTML = count > 0 ? CART_FULL_SVG : CART_EMPTY_SVG;
        wrap.style.opacity = '1';
      }, 250);
    }

    // Add bubble with pop animation
    if (count > 0) {
      if (getComputedStyle(icon).position === 'static') icon.style.position = 'relative';

      // Delay bubble to sync with SVG fade
      setTimeout(function () {
        var b = document.createElement('span');
        b.id = 'cd-cart-count-bubble';
        b.setAttribute('aria-hidden', 'true');
        b.textContent = count;
        b.style.cssText = 'position:absolute;top:0;right:-4px;background:#235a49;color:#fff;font-size:10px;font-weight:700;min-width:18px;height:18px;line-height:18px;text-align:center;border-radius:50%;padding:0 4px;pointer-events:none;z-index:9999;transform:scale(0);transition:transform .3s cubic-bezier(.34,1.56,.64,1);';

        var vh = icon.querySelector('.visually-hidden');
        if (vh) icon.insertBefore(b, vh); else icon.appendChild(b);

        // Trigger pop
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            b.style.transform = 'scale(1)';
          });
        });
      }, 280);
    }

    // Resume observer after everything settles
    setTimeout(startIconObserver, 800);
  }

  /* ── Watch for Dawn overwriting icon ── */
  function startIconObserver() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    if (_iconObserver) _iconObserver.disconnect();

    _iconObserver = new MutationObserver(function () {
      _iconObserver.disconnect();
      setTimeout(function () {
        _lastCount = -1; // force re-render
        originalFetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartBubble(cart); })
          .catch(function () {});
      }, 200);
    });
    _iconObserver.observe(icon, { childList: true, subtree: true });
  }

  /* ── Intercept fetch for cart changes ── */
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    return originalFetch.apply(this, args).then(function (res) {
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(function () {
          originalFetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartBubble(cart); })
            .catch(function () {});
        }, 500);
      }
      return res;
    });
  };

  function fireCartUpdated(cart) {
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch (e) {}
  }

  /* ── Init ── */
  function init() {
    initBanner();
    initMinusDisable();
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartBubble(cart); })
        .catch(function () {});
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var d = document.querySelector('.drawer');
  if (d) new MutationObserver(function () {
    setTimeout(function () { initBanner(); initMinusDisable(); }, 100);
  }).observe(d, { attributes: true, attributeFilter: ['class'] });
})();